<template>
  <vuetable
    :showDelete="false"
    :tableData="components"
    tableTitle="Merge Components"
    :fields="fields"
    :showEdit="true"
    @table-edit-request="goToEdit"
  ></vuetable>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import { createRouteIdHash } from '../../../helpers/RouteHash'

  export default {
    name: 'MergeComponents',
    components: {
      vuetable
    },
    props: {
      tariff: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        fields: [
          { header: 'Name', prop: 'name' },
          { header: 'Type', prop: item => item.lookupType !== null ? item.lookupType.name : '' },
          { header: 'Agent', prop: item => item.owner ? item.owner.name : '' }
        ]
      }
    },
    methods: {
      handleEdit ({item, index}) {
        this.$store.dispatch('admin/getEntity', { entity: 'lookup', id: item.id })
          .then(() => {
            this.$router.push({ name: 'Admin - Edit/View Tariff', params: { id: createRouteIdHash(item.id) } })
          })
      },
      goToEdit ({item}) {
        this.$emit('goToEdit', item.id)
      }
    },
    computed: {
      components () {
        let arr = []
        if (this.tariff.mergeComponent1) {
          arr.push(this.tariff.mergeComponent1)
        }
        if (this.tariff.mergeComponent2) {
          arr.push(this.tariff.mergeComponent2)
        }
        if (this.tariff.mergeComponent3) {
          arr.push(this.tariff.mergeComponent3)
        }
        return arr
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/admin/components/Tariff/MergeComponents.vue